import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'digires-transformer-entry-list',
  templateUrl: './transformer-entry-list.component.html',
  styleUrls: ['./transformer-entry-list.component.scss']
})
export class TransformerEntryListComponent implements OnChanges, OnDestroy {
  readonly destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() disabled: boolean;
  @Input() formGroup: FormArray;
  lastSub: Subscription;
  transformerEntries: {fg: FormGroup<{manufacturer: FormControl<string>, mvaRating: FormControl<string>}>}[] = [];

  ngOnChanges(changes: SimpleChanges) {
    this.transformerEntries = Object.values(this.formGroup.controls).map(fg => {return {fg: fg as FormGroup};});
    if (this.lastSub) {
      this.lastSub.unsubscribe();
    }
    this.lastSub = this.formGroup
      .valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const currentFgs = Object.values(this.formGroup.controls);
        if (this.transformerEntries.length !== this.formGroup.length // length is different
          || this.transformerEntries.some(e => !currentFgs.includes(e.fg)) // old entry no longer in fg
        ) {
          this.transformerEntries = currentFgs.map(fg => {return {fg: fg as FormGroup};});
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onAddEntry() {
    const fg = new FormGroup({
      id: new FormControl(),
      manufacturer: new FormControl(),
      mvaRating: new FormControl(),
    });
    this.formGroup.push(fg);
  }

  onRemoveEntry(entry: {fg: FormGroup}) {
    const idx = this.findIndexOf(entry.fg);
    if (idx >= 0) {
      this.formGroup.removeAt(idx);
    }
  }

  private findIndexOf(fg: FormGroup) {
    for (let i = 0; i < this.formGroup.length; i++) {
      if (this.formGroup.at(i) === fg) {
        return i;
      }
    }
    return -1;
  }

}
